/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {LookupTokenTypeRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {LookupTokenTypeResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const lookupTokenType = (request: LookupTokenTypeRequest, options?: CashRequestOptions) => post<LookupTokenTypeRequest, LookupTokenTypeResponse>("/2.0/cash/lookup-token-type", request, {...options, rejectOnError: true })